/** The "New booking" modal's header (BON-142). */
import { Plus, X } from 'lucide-react';

export function CreateBookingModalShellHeader({
  onClose,
  titleId,
  isSubmitting,
}: {
  onClose: () => void;
  titleId: string;
  isSubmitting: boolean;
}) {
  return (
    <div className="flex items-start justify-between gap-3 border-b border-stone-200 px-5 py-4 dark:border-stone-700">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-moss-50 text-moss-700 dark:bg-moss-900/30 dark:text-moss-300">
          <Plus size={18} />
        </span>
        <div>
          <h2
            id={titleId}
            className="text-base font-bold uppercase tracking-wide text-moss-900 dark:text-moss-300"
          >
            New booking
          </h2>
          <p className="mt-0.5 text-xs text-stone-500 dark:text-stone-400">
            Book a customer in by hand — for phone orders, partner comps, or fixing a failed
            checkout.
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        disabled={isSubmitting}
        aria-label="Close"
        className="flex-shrink-0 rounded-lg p-1.5 text-stone-400 hover:bg-stone-100 hover:text-stone-600 disabled:opacity-50 dark:hover:bg-[#252b26]"
      >
        <X size={18} />
      </button>
    </div>
  );
}
